import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ICartorioSigningContingency } from '../interface/trade/ICartorioSigningContingency';
import { bool } from "aws-sdk/clients/signer";

enum SigningConfigurationServiceEnum {
  getByTradeId = "/get-by-trade-id?tradeId=",
  postOrUpdate = "/",
  shouldSetUpCartorio = "/should-setup-cartorio?tradeId="
}

export default class SigningConfigurationService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/signing-configuration");
  }

  public getByTradeId = async (tradeId: number): Promise<ICartorioSigningContingency> => await this.GET(SigningConfigurationServiceEnum.getByTradeId + tradeId);
  public postOrUpdate = async (request: ICartorioSigningContingency) => await this.PUT(SigningConfigurationServiceEnum.postOrUpdate, request);
  public shouldSetUpCartorio = async (tradeId: number): Promise<bool> => await this.GET(SigningConfigurationServiceEnum.shouldSetUpCartorio + tradeId);
}
